import { useState, useCallback } from "react";
import FinancialRecordService from "../../../../services/financial_record_service";

const today = () => new Date().toISOString().split("T")[0];

export const useReceivablesMutations = (idTenant, authUser, refresh) => {
    const [processing, setProcessing] = useState(false);

    /**
     * Dar baixa (marcar como PAID) com dados completos.
     */
    const markAsPaid = useCallback(async (recordId, paymentData = {}) => {
        if (!idTenant || !recordId) return false;
        setProcessing(true);

        try {
            await FinancialRecordService.markAsPaid(recordId, idTenant, authUser, {
                paymentDate: paymentData.paymentDate || today(),
                idBankAccount: paymentData.idBankAccount || null,
                bankAccountName: paymentData.bankAccountName || "",
                paymentMethod: paymentData.paymentMethod || null,
                amountPaid: paymentData.amountPaid ? Number(paymentData.amountPaid) : null,
                observation: paymentData.observation || "",
                documentNumber: paymentData.documentNumber || "",
            });
            refresh();
            return true;
        } catch (err) {
            console.error("[useReceivablesMutations] Erro ao dar baixa:", err);
            return false;
        } finally {
            setProcessing(false);
        }
    }, [idTenant, authUser, refresh]);

    /**
     * Cancelar um recebível.
     */
    const cancelRecord = useCallback(async (recordId, reason = "") => {
        if (!idTenant || !recordId) return false;
        setProcessing(true);

        try {
            await FinancialRecordService.cancel(recordId, idTenant, authUser, reason);
            refresh();
            return true;
        } catch (err) {
            console.error("[useReceivablesMutations] Erro ao cancelar:", err);
            return false;
        } finally {
            setProcessing(false);
        }
    }, [idTenant, authUser, refresh]);

    return { processing, markAsPaid, cancelRecord };
};
